import { render, staticRenderFns } from "./text_image_modal.vue?vue&type=template&id=6692d38d&"
import script from "./text_image_modal.vue?vue&type=script&lang=js&"
export * from "./text_image_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../themes/chop-child/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/proservdemo25/public_html/wp-content/themes/chop-child/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6692d38d')) {
      api.createRecord('6692d38d', component.options)
    } else {
      api.reload('6692d38d', component.options)
    }
    module.hot.accept("./text_image_modal.vue?vue&type=template&id=6692d38d&", function () {
      api.rerender('6692d38d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "plugins/MtcBlockTextImageGrid/assets/components/text_image_modal.vue"
export default component.exports